// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"cd9668ba","19":"ff10d698","453":"cdae812a","627":"4a5b5d2a","631":"72f4e774","705":"089c9be4"}[chunkId] + ".chunk.js";
};